module.exports = __webpack_public_path__ + "img/DE00648.d256b34e.png";